export default __webpack_public_path__ + "static/media/home-social.c149c4d6.png";